export const shouldPlayWaitingRingtone = ({
  inCallView,
  hasWaitingCallers,
  agentCallActive,
  reviewerMonitoringActive,
}) => Boolean(
  inCallView &&
  hasWaitingCallers &&
  !agentCallActive &&
  !reviewerMonitoringActive
);

export const syncWaitingRingtone = ({
  player,
  volume,
  shouldPlay,
}) => {
  if (!player) return;
  player.volume = Math.min(1, Math.max(0, Number(volume) / 100 || 0));
  if (!shouldPlay) {
    player.pause();
    return;
  }
  void player.play().catch(() => {});
};
